import { Controller } from "@hotwired/stimulus"

// Generic click-to-expand disclosure for a block of secondary info that
// would otherwise clutter a compact view (e.g. extra school contacts on the
// Data screen header). Animates the content's height on open/close instead
// of snapping like a plain <details> or display:none toggle would -- we set
// max-height to the content's actual scrollHeight so it "unrolls" smoothly
// regardless of how much text is inside.
export default class extends Controller {
  static targets = ["content", "icon"]

  toggle(event) {
    const opening = !this.contentTarget.classList.contains("is-open")

    if (opening) {
      this.contentTarget.classList.add("is-open")
      this.contentTarget.style.maxHeight = `${this.contentTarget.scrollHeight}px`
    } else {
      this.contentTarget.style.maxHeight = null
      this.contentTarget.classList.remove("is-open")
    }

    if (this.hasIconTarget) this.iconTarget.classList.toggle("is-open", opening)
    if (event?.currentTarget) event.currentTarget.setAttribute("aria-expanded", opening)
  }
}
